<template>
	<div>
		<div class="tr h">
			<div class="play">玩法</div>
			<div class="bets">投注</div>
			<div class="mul">倍数/金额</div>
		</div>
		<div class="tr" v-for="(item, index) in matchList" :key="index">
			<div class="play">{{item.playName}}</div>
			<div class="bets">
				<div  class="ball-line" v-if="['zh_hz', 'zh_kd', 'zh_bt', 'z_fs', 'z_hz', 'z_kd', 'z_lm'].includes(item.play)">
					<div class='ball red' v-for="(ii,tt) in item.list">{{ii}}</div>
				</div>
				<div  class="ball-line"  v-if="item.play == 'zh_dt' || item.play == 'z_dt'">
					<div class="ball-line">
						<div class="no">胆码</div><div class="ball red" v-for="(ii,tt) in item.d_list">{{ii}}</div>
					</div>
					<div class="ball-line">
						<div class="no">拖码</div><div class="ball blue" v-for="(ii,tt) in item.t_list">{{ii}}</div>
					</div>
				</div>
				
				<div class="ball-line" v-if="item.play == 'zh_ds' || item.play == 'z_ds'">
					<div class="ball ">壹</div>
					<div class="ball red">{{item.list[0]}}</div>
					<div class="ball ">贰</div>
					<div class="ball red">{{item.list[1]}}</div>
					<div class="ball ">叁</div>
					<div class="ball red">{{item.list[2]}}</div>
				</div>
				<div class="ball-line" v-if="item.play == 'zh_fs'">
					<div class="ball ">壹</div>
					<div class="ball red" v-for="(ii,tt) in item.list[0]">{{ii}}</div>
					<div class="ball ">贰</div>
					<div class="ball red" v-for="(ii,tt) in item.list[1]">{{ii}}</div>
					<div class="ball ">叁</div>
					<div class="ball red" v-for="(ii,tt) in item.list[2]">{{ii}}</div>
				</div>
			</div>
			<div class="mul">{{item.mul}}倍/{{item.mul * item.count * 2}}元</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:['matchList'],
		name:"sort3",
		data() {
			return {
				
			};
		}
	}
</script>

<style scoped lang="scss">
	.tr {
		display: flex; flex-direction: row; align-items: center;
		border-bottom: solid 1px #ECECEC;
		font-size: 12px;
		.play {
			width: 90px;
			font-size: 12px;
			display: flex; flex-direction: row; align-items: center;justify-content: center;
			padding: 5px;
			color: #555555;
		}
		.bets {
			width: 140px;
			margin-right: 1px;
			border-left: solid 1px #ECECEC;
			border-right: solid 1px #ECECEC;
			display: flex; flex-direction: row; align-items: center;justify-content: center;
			flex-wrap: wrap;
			padding: 5px;
			color: #666666;
			font-size: 12px;
			.ball {
				padding: 2px;
			}
			.red {
				color: #ffffff;
				width: 12px;
				height: 12px;
				line-height: 12px;
				text-align: center;
				font-size: 12px;
				border: solid 1px #EB4C37;
				background-color: #EB4C37;
				border-radius: 12px;
				margin: 1px;
			}
			.tt {
				margin:0 2px;
			}
			.blue {
				color: white;
				width: 12px;
				height: 12px;
				line-height: 12px;
				text-align: center;
				font-size: 12px;
				border: solid 1px #3399ff;
				background-color: #3399ff;
				border-radius: 12px;
				margin: 1px;
			}
			.ball-line {
				display: flex; flex-direction: row; align-items: center; flex-wrap: wrap;
				justify-content: center;
			}
		}
		.mul {
			width: 75px;
			display: flex; flex-direction: row; align-items: center;justify-content: center;
			padding: 5px;
		}
	}
	.h {
		font-size: 12px;
		background-color: #ECECEC;
	}
</style>